import { render, staticRenderFns } from "./NotificationService.vue?vue&type=template&id=287f8fca&scoped=true&lang=pug&"
import script from "./NotificationService.vue?vue&type=script&lang=js&"
export * from "./NotificationService.vue?vue&type=script&lang=js&"
import style0 from "./NotificationService.vue?vue&type=style&index=0&id=287f8fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287f8fca",
  null
  
)

export default component.exports